module.exports = __webpack_public_path__ + "img/img_5.a64eafd3.png";